import { render, staticRenderFns } from "./TControl.vue?vue&type=template&id=7e95862c&scoped=true&"
import script from "./TControl.vue?vue&type=script&lang=ts&"
export * from "./TControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e95862c",
  null
  
)

export default component.exports